import { proxyCustomElement, HTMLElement, createEvent, h, Fragment } from '@stencil/core/internal/client';
import { M as METHOD_MODULE } from './index2.js';
import { d as defineCustomElement$4 } from './button-base2.js';
import { d as defineCustomElement$3 } from './nl-change-account2.js';
import { d as defineCustomElement$2 } from './nl-dialog2.js';
import { d as defineCustomElement$1 } from './ns-login-status.js';

import { baseCss } from './css.js';
const nlBannerCss = baseCss;

const NlBannerStyle0 = nlBannerCss;

const NlBanner = /*@__PURE__*/ proxyCustomElement(class NlBanner extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.handleNotifyConfirmBanner = createEvent(this, "handleNotifyConfirmBanner", 7);
        this.handleNotifyConfirmBannerIframe = createEvent(this, "handleNotifyConfirmBannerIframe", 7);
        this.handleLoginBanner = createEvent(this, "handleLoginBanner", 7);
        this.handleLogoutBanner = createEvent(this, "handleLogoutBanner", 7);
        this.handleOpenWelcomeModal = createEvent(this, "handleOpenWelcomeModal", 7);
        this.handleConfirmLogout = createEvent(this, "handleConfirmLogout", 7);
        this.handleImportModal = createEvent(this, "handleImportModal", 7);
        this.theme = 'default';
        this.darkMode = false;
        this.hiddenMode = false;
        this.titleBanner = '';
        this.isOpen = false;
        this.isLoading = false;
        this.notify = null;
        this.userInfo = null;
        this.accounts = [];
        this.isUserImgError = false;
        this.domain = '';
        this.mode = '';
        this.url = '';
        this.isOpenConfirm = false;
    }
    watchNotifyHandler(notify) {
        var _a, _b, _c, _d;
        this.isOpen = true;
        this.isOpenConfirm = true;
        this.domain = ((_a = this.userInfo) === null || _a === void 0 ? void 0 : _a.domain) || ((_d = (_c = (_b = this.userInfo) === null || _b === void 0 ? void 0 : _b.nip05) === null || _c === void 0 ? void 0 : _c.split('@')) === null || _d === void 0 ? void 0 : _d[1]) || '';
        this.mode = notify.mode;
        this.url = notify.url;
        if (!this.mode) {
            this.isOpenConfirm = false;
            this.isOpen = false;
        }
    }
    handleOpen() {
        if (this.userInfo) {
            this.isOpen = true;
        }
        else {
            this.handleOpenWelcomeModal.emit();
        }
    }
    handleClose() {
        this.isOpen = false;
    }
    handleLogin() {
        this.handleLoginBanner.emit(METHOD_MODULE.LOGIN);
        this.handleClose();
    }
    handleSignup() {
        this.handleLoginBanner.emit(METHOD_MODULE.SIGNUP);
        this.handleClose();
    }
    handleImport() {
        this.handleImportModal.emit();
        this.handleClose();
    }
    handleLogout() {
        const isBackupKey = localStorage.getItem('backupKey');
        if (isBackupKey) {
            this.handleLogoutBanner.emit(METHOD_MODULE.LOGOUT);
            this.handleClose();
            localStorage.removeItem('backupKey');
            return;
        }
        if (this.userInfo.authMethod === 'local') {
            this.handleConfirmLogout.emit();
        }
        else {
            this.handleLogoutBanner.emit(METHOD_MODULE.LOGOUT);
        }
        this.handleClose();
    }
    handleConfirm() {
        switch (this.mode) {
            case 'authUrl':
                this.handleNotifyConfirmBanner.emit(this.url);
                break;
            case 'iframeAuthUrl':
                this.handleNotifyConfirmBannerIframe.emit(this.url);
                break;
        }
        this.handleClose();
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        const isShowImg = Boolean((_a = this.userInfo) === null || _a === void 0 ? void 0 : _a.picture);
        const userName = ((_b = this.userInfo) === null || _b === void 0 ? void 0 : _b.name) || ((_e = (_d = (_c = this.userInfo) === null || _c === void 0 ? void 0 : _c.nip05) === null || _d === void 0 ? void 0 : _d.split('@')) === null || _e === void 0 ? void 0 : _e[0]) || ((_f = this.userInfo) === null || _f === void 0 ? void 0 : _f.pubkey) || '';
        const isShowUserName = Boolean(userName);
        const isTemporary = this.userInfo && this.userInfo.authMethod === 'local';
        const isBackupKey = localStorage.getItem('backupKey');
        const defaultUserAvatar = (h("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", class: "w-full" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" })));
        const content = (h(Fragment, null, h("div", { class: "block w-[48px] h-[46px] relative z-10" }, h("div", { onClick: () => this.handleOpen(), class: `flex w-52 h-[46px] items-center pl-[11px]` }, h("span", { class: `${this.isLoading ? 'w-5 h-5 border-[2px] mr-3.5 ml-[2px] opacity-1' : 'w-0 h-0 border-[0px] mr-0 opacity-0 ml-0'} animate-spin transition-all duration-300 ease-in-out inline-block border-current border-t-transparent text-slate-900 dark:text-gray-300 rounded-full`, role: "status", "aria-label": "loading" }), this.userInfo ? (h("div", { class: `uppercase font-bold w-6 h-6 mr-2 rounded-full border border-gray-200 flex justify-center items-center` }, isShowImg ? (this.isUserImgError ? (defaultUserAvatar) : (h("img", { class: "w-full rounded-full", src: this.userInfo.picture, alt: "Logo", onError: () => (this.isUserImgError = true) }))) : isShowUserName ? (userName[0]) : (defaultUserAvatar))) : (h("div", { class: "flex justify-center items-center" }, h("svg", { class: "w-6 h-6", width: "225", height: "224", viewBox: "0 0 225 224", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("rect", { width: "224.047", height: "224", rx: "64", fill: "#6951FA" }), h("path", { d: "M162.441 135.941V88.0593C170.359 85.1674 176 77.5348 176 68.6696C176 57.2919 166.708 48 155.33 48C143.953 48 134.661 57.2444 134.661 68.6696C134.661 77.5822 140.302 85.1674 148.219 88.0593V135.941C147.698 136.13 147.176 136.367 146.655 136.604L87.3956 77.3452C88.6282 74.6904 89.2919 71.7511 89.2919 68.6696C89.2919 57.2444 80.0474 48 68.6696 48C57.2919 48 48 57.2444 48 68.6696C48 77.5822 53.6415 85.1674 61.5585 88.0593V135.941C53.6415 138.833 48 146.465 48 155.33C48 166.708 57.2444 176 68.6696 176C80.0948 176 89.3393 166.708 89.3393 155.33C89.3393 146.418 83.6978 138.833 75.7807 135.941V88.0593C76.3022 87.8696 76.8237 87.6326 77.3452 87.3956L136.604 146.655C135.372 149.31 134.708 152.249 134.708 155.33C134.708 166.708 143.953 176 155.378 176C166.803 176 176.047 166.708 176.047 155.33C176.047 146.418 170.406 138.833 162.489 135.941H162.441Z", fill: "white" })), this.isOpen && (h("span", { class: "px-2" }, h("b", null, "Nostr"), " Login")))), this.isOpen && isShowUserName && h("div", { class: "show-slow truncate w-16 text-xs" }, userName), this.isOpen && isShowUserName && h("nl-login-status", { info: this.userInfo }))), h("button", { onClick: () => this.handleClose(), type: "button", class: `${this.isOpen ? 'z-20' : 'z-0'} nl-action-button absolute right-2 top-2 z-0 show-slow grid place-items-center w-7 h-7 text-sm font-semibold rounded-full border border-transparent` }, h("span", { class: "sr-only" }, "Close"), h("svg", { class: "flex-shrink-0 w-5 h-5", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, h("path", { d: "M18 6 6 18" }), h("path", { d: "m6 6 12 12" }))), h("div", { class: "p-3 show-slow" }, this.isOpenConfirm ? (h("div", null, h("div", { class: "w-8 h-8 p-1/2 rounded-full border border-gray-200 bg-white mb-2 mt-2 show-slow m-auto" }, h("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "#5a68ff", class: "w-full" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" }))), h("p", { class: "mb-2 text-center max-w-40 min-w-40 mx-auto" }, this.mode === 'timeout' ? 'Keys not responding, check your key storage app' : `Confirmation required at ${this.domain}`), this.mode === 'timeout' ? (h("a", { onClick: () => this.handleClose(), href: `https://${this.domain}`, target: "_blank", class: "nl-button text-nowrap py-2.5 px-3 w-full inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" }, "Go to ", this.domain)) : this.mode === 'rebind' ? (h("iframe", { src: this.url, width: '180', height: '80', frameBorder: '0' })) : (h("button-base", { onClick: () => this.handleConfirm(), titleBtn: "Confirm" })))) : (h("div", null, h("div", null, this.titleBanner && h("p", { class: "mb-2 text-center show-slow max-w-40 min-w-40 mx-auto" }, this.titleBanner), isTemporary && (h(Fragment, null, !isBackupKey && h("p", { class: "mb-2 text-center show-slow text-red-400 max-w-40 min-w-40 mx-auto" }, "Your profile may be lost if you close this tab"), h("div", { class: "mb-2" }, h("button-base", { onClick: () => this.handleImport(), theme: "lemonade", titleBtn: "Back up profile" })))), h("div", { class: "mb-2" }, h("nl-change-account", { currentAccount: this.userInfo, accounts: this.accounts })), !this.userInfo ? (h("div", null, h("button-base", { onClick: () => this.handleLogin(), titleBtn: "Log in" }, h("svg", { style: { display: 'none' }, slot: "icon-start", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", class: "flex-shrink-0 w-4 h-4" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z" }))), h("button-base", { onClick: () => this.handleSignup(), titleBtn: "Sign up" }, h("svg", { style: { display: 'none' }, slot: "icon-start", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", class: "flex-shrink-0 w-4 h-4" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z" }))))) : (h("button-base", { onClick: () => this.handleLogout(), titleBtn: "Log out" }))))))));
        // https://gist.github.com/Haprog/848fc451c25da00b540e6d34c301e96a
        function deepQuerySelectorAll(selector, root) {
            root = root || document.body;
            const results = Array.from(root.querySelectorAll(selector));
            const pushNestedResults = function (root) {
                deepQuerySelectorAll(selector, root).forEach(elem => {
                    if (!results.includes(elem)) {
                        results.push(elem);
                    }
                });
            };
            if (root.shadowRoot) {
                pushNestedResults(root.shadowRoot);
            }
            for (const elem of Array.from(root.querySelectorAll('*'))) {
                if (elem.shadowRoot) {
                    pushNestedResults(elem.shadowRoot);
                }
            }
            return results;
        }
        const dialogs = deepQuerySelectorAll('dialog');
        const needDialog = !!dialogs.find(d => d.open && !d.classList.contains('nl-banner-dialog'));
        return (h("div", { class: `theme-${this.theme} ${!this.isOpen && this.hiddenMode ? 'hidden' : ''}` }, h("div", { class: this.darkMode && 'dark', dir: "ltr" }, this.isOpenConfirm && needDialog ? (h("nl-dialog", null, h("div", { class: `nl-banner ${this.isOpen ? 'w-52 h-auto right-2 rounded-r-lg isOpen ' : 'rounded-r-none hover:rounded-r-lg cursor-pointer'} z-50 w-12 h-12 fixed top-52 right-0 inline-block gap-x-2 text-sm font-medium  rounded-lg hover:right-2  transition-all duration-300 ease-in-out` }, content))) : (h("div", { class: `nl-banner ${this.isOpen ? 'w-52 h-auto right-2 rounded-r-lg isOpen' : 'rounded-r-none hover:rounded-r-lg cursor-pointer'} z-50 w-12 h-12 fixed top-52 right-0 inline-block gap-x-2 text-sm font-medium  rounded-lg hover:right-2  transition-all duration-300 ease-in-out` }, content)))));
    }
    static get watchers() { return {
        "notify": ["watchNotifyHandler"]
    }; }
    static get style() { return NlBannerStyle0; }
}, [1, "nl-banner", {
        "theme": [1025],
        "darkMode": [1028, "dark-mode"],
        "hiddenMode": [1028, "hidden-mode"],
        "titleBanner": [1, "title-banner"],
        "isOpen": [1028, "is-open"],
        "isLoading": [4, "is-loading"],
        "notify": [16],
        "userInfo": [16],
        "accounts": [1040],
        "isUserImgError": [32],
        "domain": [32],
        "mode": [32],
        "url": [32],
        "isOpenConfirm": [32]
    }, undefined, {
        "notify": ["watchNotifyHandler"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-banner", "button-base", "nl-change-account", "nl-dialog", "nl-login-status"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-banner":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlBanner);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "nl-change-account":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "nl-dialog":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "nl-login-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlBanner as N, defineCustomElement as d };

//# sourceMappingURL=nl-banner2.js.map